<div class="rec-container ">
  <h2>Search Recorded Land by</h2>
  <form (ngSubmit)="onSubmit($event)" #f="ngForm">
    <div class="name-role-container mb-55" [ngStyle]="{'height': (screenWidth > 768) ? '123px' : fnameShow ? '279px' : '186px'}">
      <div class="name-container" [ngStyle]="{'height': (screenWidth > 768) ? 'Initial' : fnameShow ? '186px' : '93px'}">
        <app-compound-name-idx [fnameShow]="fnameShow"></app-compound-name-idx>
      </div>
      <div class="drange-container">
        <div class="space"></div>
        <app-date-range-unindex [majorgroup]="majorgroup"></app-date-range-unindex>
      </div>
    </div>
    <button class="btn btn-default" type="submit">
      SEARCH
    </button>
    <div class="index-container">
      <label>Select Name to view images</label>
      <div class="index-list">
        <dx-list itemSize="20" class="parties-viewport" [dataSource]="results" itemTemplate="Indexes" (onItemClick)="ItemClick($event)" [useNativeScrolling]="false" showScrollBar="always">
          <div class="item-parties" *dxTemplate="let r of 'Indexes'" style="padding:1px;">
            {{r.indexName}}
          </div>
        </dx-list>
      </div>
    </div>
  </form>
</div>
